export function toLocalePercent(value: number, maximumFractionDigits = 1) {
  return value.toLocaleString(undefined, {
    maximumFractionDigits,
    style: "percent",
  });
}
